var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88571 16.5159V14.8614C4.88571 13.9159 5.20952 13.128 5.85714 12.4977C6.50476 11.8674 7.28572 11.5523 8.2 11.5523H9.42857V9.60227L12.1714 12.4386L9.42857 15.275V13.325H8.2C7.76191 13.325 7.38571 13.4727 7.07143 13.7682C6.75714 14.0636 6.6 14.428 6.6 14.8614V16.5159H4.88571ZM1.71429 26C1.25714 26 0.857143 25.8227 0.514286 25.4682C0.171428 25.1136 0 24.7 0 24.2273V1.77273C0 1.3 0.171428 0.886364 0.514286 0.531818C0.857143 0.177273 1.25714 0 1.71429 0H14.2857C14.7429 0 15.1429 0.177273 15.4857 0.531818C15.8286 0.886364 16 1.3 16 1.77273V24.2273C16 24.7 15.8286 25.1136 15.4857 25.4682C15.1429 25.8227 14.7429 26 14.2857 26H1.71429ZM1.71429 23.3409V24.2273H14.2857V23.3409H1.71429ZM1.71429 21.5682H14.2857V4.43182H1.71429V21.5682ZM1.71429 2.65909H14.2857V1.77273H1.71429V2.65909Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.31a0d325148b642b022e1915ce4a4c6e.svg";
export { ForwardRef as ReactComponent };